import { render, staticRenderFns } from "./AgreementsAuto.vue?vue&type=template&id=689d5fd0&"
import script from "./AgreementsAuto.vue?vue&type=script&lang=js&"
export * from "./AgreementsAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports